module.exports = __webpack_public_path__ + "img/pirinola-icon.479b49f6.png";